<template>

  <div class="psocket">
    <div id="PSocket"></div>
  </div>

</template>

<script>
  export default {
    props: ['attributes', 'flashvars'],
    methods: {
      createPSocket () {

        let swfVersionStr = "25.0.0"

        let flashvars = {}

        let params = {}
        params.allowscriptaccess = 'always'
        params.allownetworking = 'all'

        let psocket_url =  process.env.PSOCKET_SWF

        swfobject.embedSWF(
            psocket_url, "PSocket",
            "100%", "100%",
            swfVersionStr, '',
            this.flashvars, params, this.attributes)

      }
    },
    mounted () {
        let platform = this.$route.query.platform;
        console.log("psocket platfom:::", platform);
        if(platform == "qt") {
            this.createPSocket();
        }
    }
  }
</script>

<style lang="stylus">
  .psocket
    position: absolute
    left: 0 !important
    top: 0 !important
    z-index: -1
</style>



// WEBPACK FOOTER //
// PSocket.vue?ad3899f2